import {
  GET_BUSINESS_OVERVIEW_DATA,
  GET_BUSINESS_OVERVIEW_DATA_SUCCESS,
  GET_BUSINESS_OVERVIEW_DATA_ERROR,
} from "./actionType";

const INIT_STATE = {
  businessOverviewData: null,
  loadingBusinessOverviewData: false,
  error: null,
};

const BusinessOverview = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BUSINESS_OVERVIEW_DATA:
      return {
        ...state,
        loadingBusinessOverviewData: true,
      };
    case GET_BUSINESS_OVERVIEW_DATA_SUCCESS:
      return {
        ...state,
        loadingBusinessOverviewData: false,
        businessOverviewData: action.payload,
      };
    case GET_BUSINESS_OVERVIEW_DATA_ERROR:
      return {
        ...state,
        loadingBusinessOverviewData: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default BusinessOverview;
